(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _StoreLocator = _interopRequireDefault(require("./modules/StoreLocator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PMDMS = PMDMS || {};

PMDMS.Frontend = function ($) {
  $(document).ready(function () {
    new _StoreLocator["default"](".astra_location_selector");
  });
}(jQuery);

},{"./modules/StoreLocator":2}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var StoreLocator = /*#__PURE__*/function () {
  function StoreLocator(selector) {
    _classCallCheck(this, StoreLocator);

    this.selection_in_progress = false;
    this.store_locator_element = jQuery(selector);
    this.checkExistingLocation();
    this.checkLocationListeners();
  }

  _createClass(StoreLocator, [{
    key: "checkLocationListeners",
    value: function checkLocationListeners() {
      var _self = this;

      jQuery("body").on("click", ".setlocation a", function (e) {
        e.preventDefault();

        if (_self.selection_in_progress) {
          return;
        }

        var clicked_element = jQuery(this);

        _self.setSelectionInProgress(clicked_element);

        _self.getStoreLocatorContent(clicked_element.data("location-post-id"));
      });
    }
  }, {
    key: "checkExistingLocation",
    value: function checkExistingLocation() {
      if (this.store_locator_element.hasClass("astra_location_selector_placeholder")) {
        this.getStoreLocatorContent();
      }
    }
  }, {
    key: "setSelectionInProgress",
    value: function setSelectionInProgress(button) {
      button.addClass("setlocation--loading");
      this.selection_in_progress = true;
    }
    /**
     * Reset selection link on "Select a Location" page
     */

  }, {
    key: "resetSetSelectionLink",
    value: function resetSetSelectionLink() {
      jQuery(".setlocation--loading").removeClass("setlocation--loading");
      this.selection_in_progress = false;
    }
  }, {
    key: "getStoreLocatorContent",
    value: function getStoreLocatorContent() {
      var selected_location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _self = this;

      this.getLocationData(selected_location).then(function (data) {
        data.action = "get_store_location_content";
        data.nonce = store_location_localized_args.nonce;
        jQuery.ajax({
          type: "POST",
          url: store_location_localized_args.url,
          data: data,
          success: function success(response) {
            var _response$data = response.data,
                html = _response$data.html,
                shipping_zone_id = _response$data.shipping_zone_id,
                using_store_postal = _response$data.using_store_postal; // Show the store location on the frontend GUI

            _self.store_locator_element.replaceWith(html);

            _self.store_locator_element = jQuery(".astra_location_selector"); // Reset store selection link (if on "Select a Location" page)

            _self.resetSetSelectionLink(); // No shipping zone, or a store's postal is being used for the customer so we show the modal


            if (!selected_location && (using_store_postal || !shipping_zone_id)) {
              jQuery(".outsidezone").modal({
                fadeDuration: 1000,
                fadeDelay: 0.5
              });
            }
          }
        });
      });
    }
  }, {
    key: "getLocationData",
    value: function getLocationData(Location) {
      var data = {};
      return new Promise(function (resolve, reject) {
        // Location is already set
        if (Location !== null) {
          data.astra_store_location = Location;
          resolve(data);
        } // Geolocation isn't available
        else if (!navigator.geolocation) {
            resolve(data);
          } // Geolocation position
          else {
              var options = {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
              };
              navigator.geolocation.getCurrentPosition(function (position) {
                // console.log("Position:", position);
                // console.table("Latitude: ", position.coords.latitude, "Longitude: ", position.coords.longitude);
                data.astra_x_pos = position.coords.latitude;
                data.astra_y_pos = position.coords.longitude; // TESTING!!!
                // data.postal = "N0R 1K0";
                // data.postal = "B2S 1K0";
                // resolve(data);
                // return;
                // Get postal code from Google Maps

                var point = new google.maps.LatLng(data.astra_x_pos, data.astra_y_pos);
                console.log("point", point);
                new google.maps.Geocoder().geocode({
                  latLng: point
                }, function (res, status) {
                  if (!res.length) {
                    resolve(data);
                  } // The first address will be the most accurate (I assume via test results)


                  var address_components = res[0].address_components; // console.log("address_components", address_components);
                  // Try to find the postal code from address components

                  for (var i = 0; i < address_components.length; i++) {
                    var postal_index = address_components[i].types.indexOf("postal_code"); // console.log(address_components[i].types);

                    if (postal_index > -1) {
                      data.postal = address_components[i].long_name;
                      resolve(data);
                      break;
                    }
                  } // If nothing was resolved via postal code, return the empty data object


                  resolve(data);
                });
              }, function (err) {
                console.error("store location error:", err);
                resolve(data);
              }, options);
            }
      });
    }
  }]);

  return StoreLocator;
}();

exports["default"] = StoreLocator;

},{}]},{},[1]);
